import { type ComponentType, lazy } from "react";
import type { CreditCardFormContainerProps } from "./CreditCardFormContainer";
import type { CreditCardInputsProps } from "./CreditCardInputs";
import { validateAdyenCardDetails } from "helpers/validation/online_ordering/payment/adyen/adyenFormValidations";
import { adyenTransformPayload } from "helpers/validation/online_ordering/payment/adyen/adyenTransformPayload";
import type { CCProcessor } from "types/payments/credit_card";
import type { PaymentReturnUrlAuthorizationProps } from "types/payments/PaymentReturnUrlAuthorizationProps";
import type { IErrors, INewCreditCard } from "types/reducers/payment";
import type { IOrderPayload } from "types/totals";

export interface CCProcessorConfiguration {
  formContainer: ComponentType<CreditCardFormContainerProps<any>>;
  ccInput: ComponentType<CreditCardInputsProps>;
  validator?: {
    bivarianceHack(newCreditCard: INewCreditCard): IErrors | null;
  }["bivarianceHack"];
  transformPayload?: {
    bivarianceHack(payload: IOrderPayload, card: INewCreditCard): IOrderPayload;
  }["bivarianceHack"];
  /**
   * @deprecated a temporary attribute to prevent huge refactoring.
   *  If you need to implement storing credit card,
   *  implement in their form container or return url authorization.
   */
  isStoringCreditCardEnabled?: boolean;
  /**
   * It indicates `orderStatus` would be updated by the individual cc processor flow
   * instead of being marked as complete after the POST `/order` call completes.
   */
  isCustomizedSubmitProcessing: boolean;
  /**
   * The component that handles credit card authorization on return url
   */
  returnUrlAuthorization?: ComponentType<PaymentReturnUrlAuthorizationProps>;
}

export const CCProcessorConfigurationMap: Record<
  CCProcessor,
  CCProcessorConfiguration
> = {
  adyen: {
    formContainer: lazy(() => import("./adyen/AdyenOLOForm")),
    ccInput: lazy(() => import("./adyen/AdyenOLOCreditCardInputs")),
    validator: validateAdyenCardDetails,
    transformPayload: adyenTransformPayload,
    returnUrlAuthorization: lazy(
      () => import("./adyen/AdyenOLOPaymentReturnUrlAuthorization")
    ),
    isCustomizedSubmitProcessing: true,
  },
  firstData: {
    formContainer: lazy(() => import("./first_data/FirstDataFormContainer")),
    ccInput: lazy(() => import("./first_data/FirstDataCreditCardInputs")),
    isStoringCreditCardEnabled: true,
    isCustomizedSubmitProcessing: false,
  },
};
